<!-- INTRO SECTION -->
<section class="section intro">
  <div class="wrapper">
    <div class="pager">
      <div class="pager__line"></div>
      <ul class="pager__dots">
        <li class="pager__dot"></li>
        <li class="pager__dot"></li>
        <li class="pager__dot"></li>
      </ul>
    </div>
    <h1 class="intro__title">Wir glauben an<br />Ihre Vision</h1>
    <h2 class="intro__text">
      Wir sind leidenschaftlich innovativ und möchten Ihre Ideen Wirklichkeit werden lassen.
    </h2>
    <app-button [href]="'mailto:contact@coara.co'" text="Kontakt aufnehmen" class="intro__button"></app-button>
    <ng-lottie
      containerClass="intro__animation"
      [options]="mouseAnimation"
      width="65px"
      height="169px"
      (animationCreated)="animationCreated($event)"
    ></ng-lottie>
  </div>
</section>

<!-- MAIN BANNER -->
<section class="section main-banner">
  <div class="main-banner__wrapper">
    <h3 class="main-banner__title">Die Startup-Agentur</h3>
    <p class="main-banner__text">
      Wir unterstützen Gründer dabei, schneller zu innovieren und zu entwickeln. Wir sind ein Inkubator für Ihre Idee, Ihre Entwickler, ein
      Beschleuniger für Ihr Geschäft und ein Growth-Hack zur Kundengewinnung.
    </p>
    <div class="main-banner__footer">
      <app-button
        [routerLinkDelagate]="PATHS[ROUTES.WHAT]"
        blackOnMobile="true"
        text="Was wir tun"
        class="main-banner__button"
      ></app-button>
      <div class="main-banner__footer__text">Design und Entwicklung digitaler Produkte</div>
    </div>
  </div>
</section>

<!-- BUILDING SECTION -->
<section class="section building --with-carousel">
  <h2 class="section__title">Gemeinsam Produkte entwickeln</h2>
  <app-carousel>
    <div class="building__item">
      <picture class="building__item__img">
        <source *ngFor="let type of ['webp', 'jpg']" srcset="{{'/assets/images/building/001.' + type}}" type="image/{{ type }}" />
        <img loading="lazy" src="/assets/images/building/001.jpg" alt="ideation" />
      </picture>
      <p class="building__item__title">01. Ideenfindung</p>
      <p class="building__item__text">
        Definieren und gestalten Sie Ihr Produkt und schaffen Sie eine perfekte Nutzererfahrung. Erforschen Sie Kundenbedürfnisse und
        Marktstrategie.
      </p>
    </div>
    <div class="building__item">
      <picture class="building__item__img">
        <source *ngFor="let type of ['webp', 'jpg']" srcset="{{'/assets/images/building/002.' + type}}" type="image/{{ type }}" />
        <img loading="lazy" src="/assets/images/building/002.jpg" alt="Bulding" />
      </picture>
      <p class="building__item__title">02. Entwicklung</p>
      <p class="building__item__text">Erstellen Sie echte MVPs und entwickeln Sie mit Hilfe Ihrer frühen Anwender das perfekte Produkt.</p>
    </div>
    <div class="building__item">
      <picture class="building__item__img">
        <source *ngFor="let type of ['webp', 'jpg']" srcset="{{'/assets/images/building/003.' + type}}" type="image/{{ type }}" />
        <img loading="lazy" src="/assets/images/building/003.jpg" alt="Growth" />
      </picture>
      <p class="building__item__title">03. Wachstum</p>
      <p class="building__item__text">
        Setzen Sie die richtigen Hebel, um Ihre ersten Kunden zu gewinnen und definieren Sie Ihren Wachstumsmotor für Nachhaltigkeit.
      </p>
    </div>
  </app-carousel>
</section>

<!-- LEAN BANNER -->
<div class="lean-banner">
  <h3 class="lean-banner__title">Ihr Lean Startup</h3>
  <div class="lean-banner__wrapper">
    <div class="lean-banner__content">
      <div class="lean-banner__item">
        <div class="lean-banner__item__image">
          <img loading="lazy" src="/assets/images/lean-banner/002.png" alt="Lean icon" />
        </div>
        <p class="lean-banner__item__text">Ziele setzen und definieren</p>
      </div>
      <div class="lean-banner__item">
        <div class="lean-banner__item__image">
          <img loading="lazy" src="/assets/images/lean-banner/004.png" alt="Car icon" />
        </div>
        <p class="lean-banner__item__text">Starten Sie früh!</p>
      </div>
      <div class="lean-banner__item">
        <div class="lean-banner__item__image">
          <img loading="lazy" src="/assets/images/lean-banner/001.png" alt="Atom icon" />
        </div>
        <p class="lean-banner__item__text">Messen und schnell lernen</p>
      </div>
      <div class="lean-banner__item">
        <div class="lean-banner__item__image">
          <img loading="lazy" src="/assets/images/lean-banner/003.png" alt="Iteration logo" />
        </div>
        <p class="lean-banner__item__text">Iterieren und verbessern</p>
      </div>
    </div>
  </div>
</div>

<!-- SENTENCE -->
<section class="section sentence">
  <div class="sentence__wrapper">
    <p class="sentence__text">
      Wenn Sie Angst vor Misserfolg oder Fehlern haben, werden Sie niemals wirklich innovativ sein oder den Markt verändern.
      <br />
      <span class="signature">Gillian Tans, CEO booking.com</span>
    </p>
    <ng-lottie [options]="infiniteCirclesAnimation" width="100%" height="auto" (animationCreated)="animationCreated($event)"></ng-lottie>
  </div>
</section>

<!-- LABYRINTH -->
<section class="section labyrinth">
  <div class="labyrinth__content">
    <h2 class="section__title">Sie sind ein Unternehmens-Team und wollen dem Labyrinth entkommen</h2>
    <p class="section__text">Sie möchten ein internes Innovationsprojekt in Ihrem Unternehmen vorantreiben?</p>
    <p class="section__list-title">Aber</p>
    <ul class="section__list">
      <li class="section__list__item">Ihre Vorstellungskraft wird durch Unternehmensprozesse eingeschränkt</li>
      <li class="section__list__item">Sie wollen schnell vorankommen, aber IT-Einschränkungen und -Ressourcen halten Sie zurück?</li>
      <li class="section__list__item">Markeneinschränkungen erlauben keine Disruption Ihres Kerngeschäfts?</li>
    </ul>
  </div>
  <ng-lottie [options]="labyrinthAnimation" width="100%" height="auto" (animationCreated)="animationCreated($event)"></ng-lottie>
</section>

<!-- OUR WORK -->
<section class="section work --with-carousel">
  <h2 class="section__title">
    <h3 class="section__title__wrapper">
      Brechen Sie aus und
      <br />
      innovieren Sie wirklich!
      <br />
      <app-button [routerLinkDelagate]="PATHS[ROUTES.WORKS]" text="Unsere Arbeit"></app-button>
    </h3>
  </h2>
  <app-carousel>
    <a class="work__item" [routerLink]="[PATHS[ROUTES.WORKS], project.uri]" *ngFor="let project of projectsToShow; let i = index">
      <picture class="work__item__image">
        <source *ngFor="let type of ['webp', 'jpg']" srcset="{{project?.thumbnail?.image + '.' + type}}" type="image/{{ type }}" />
        <img [attr.loading]="i <= 3 ? 'eager' : 'lazy'" src="{{ project?.thumbnail?.image }}.jpg" alt="{{ project?.thumbnail?.alt }}" />
      </picture>
    </a>
  </app-carousel>
</section>

<!-- SECTION CONTACT -->
<section class="section contact">
  <div *ngIf="!leadSent" class="contact__wrapper">
    <h3 class="section__title">Anmelden oder verpassen</h3>
    <form [formGroup]="form" class="contact__form">
      <label for="email" class="contact__form__label">Ihre E-Mail</label>
      <div class="contact__form__item">
        <input
          name="email"
          formControlName="email"
          type="text"
          placeholder="Ja. Das ist wirklich ein großes Eingabefeld"
          class="contact__form__input"
        />
        <button
          type="submit"
          class="contact__form__button"
          [disabled]="form.invalid"
          [class.--disabled]="form.invalid"
          (click)="sendLead()"
        >
          Abonnieren
        </button>
      </div>
      <p class="contact__text">Kein Spam. Keine Werbung. Versprochen.</p>
    </form>
  </div>
  <div *ngIf="leadSent" class="contact__wrapper">
    <h2 class="section__title">Wir melden uns, danke!</h2>
  </div>
</section>

<!-- SECTION CLIENTS -->
<section class="section clients">
  <div class="clients__wrapper">
    <h2 class="section__title">Sie können nicht aufhören zu lächeln</h2>
    <ul class="clients__grid">
      <div class="clients__item">
        <img loading="lazy" src="/assets/images/clients/volkswagen.png" alt="volkswagen" />
      </div>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/intersport.png" alt="intersport" />
      </li>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/p4m.png" alt="Convercus" />
      </li>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/urban.png" alt="Urban drive style" />
      </li>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/iqsales.png" alt="Value IQ" />
      </li>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/condor.png" alt="Condor" />
      </li>
      <li class="clients__item">
        <img loading="lazy" src="/assets/images/clients/callista.png" alt="Callista" />
      </li>
      <li class="clients__item --bg-white">
        <span class="clients__item__text">Ihr Logo würde hier gut aussehen</span>
        <i-feather name="arrow-right" class="clients__item__icon"></i-feather>
      </li>
      <div class="clients__item --empty"></div>
    </ul>
  </div>
</section>
